<template>
    <div class="recaptcha-attribution">
        <span>
            This site is protected by reCAPTCHA Enterprise and the Google
            <a
                data-cy="link-recaptcha-privacy"
                place="privacyLink"
                :href="privacyLink"
                target="_blank"
                rel="external"
                >{{ `Privacy Policy` }}</a
            >
            and
            <a
                data-cy="link-recaptcha-terms"
                place="tosLink"
                :href="tosLink"
                target="_blank"
                rel="external"
                >{{ `Terms of Service` }}</a
            >
            apply.
        </span>
    </div>
</template>

<script>
export default {
    name: 'RecaptchaAttribution',
    computed: {
        tosLink() {
            return `https://policies.google.com/terms?hl=en`;
        },
        privacyLink() {
            return `https://policies.google.com/privacy?hl=en`;
        },
    },
};
</script>

<style lang="scss" scoped>
.recaptcha-attribution {
    line-height: 1.42;
    color: grey;
    font-size: 12px;
    a {
        color: inherit;
        text-decoration: underline;
    }
}
</style>
